module.exports = __webpack_public_path__ + "media/video.a16d97d7.mp4";